import React from 'react'
import FooterShared from '../../../shared/components/molecules/footer/footer'

import './footer.scss'

const Footer = (props) => {

  const {isMobile} = props
  
  return (
    <div className="f-inngenio-footer">
      {
        !isMobile 
        ?
          <div className="f-figure-footer"> </div>
        :
        null
      }
      
      <FooterShared countriesInclude={false} />
    </div>
  )
}

export default Footer
